import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { Store } from '@ngrx/store';
import { selectUserId } from '../../auth/store/auth.selector';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulesApiService {

  apiUrl = environment.apiUrl

  // Minimum end date (D) requirement for schedule form validation.
  // Source of truth for UI validation.
  minEndDate = '2024-01-01';

  constructor(private http: HttpClient,private store: Store) { }


  getgoogleAuthCheck() {
    return this.http.get(`${this.apiUrl}google/redirect`);
  }

  checkUserCalendarToken(): Observable<any> {
    return this.store.select(selectUserId).pipe(
      switchMap((id:any) => {
        if (id) {
          return this.http.get(`${this.apiUrl}google/check-google-authentication/${id}`);
        } else {
          return of(null);
        }
      })
    );
  }

  scheduleEvent(data: any) {
    return this.http.post(`${this.apiUrl}classroom/event/schedule-event`, data);
  }

  updateEvent(eventId: string | number, data: any) {
    return this.http.post(`${this.apiUrl}classroom/edit-event/${eventId.toString().replace('evt-', '')}`, data);
  }
  deleteScheduleEvent(eventId: string | number) {
    console.log('Deleting event with ID:', eventId);
    return this.http.get(`${this.apiUrl}classroom/delete-event/${eventId.toString()}`);
  }

  getAllCalendarEvents() {
    return this.http.get(`${this.apiUrl}classroom/all-events`);
  }

  getEventById(eventId: string | number) {
    const normalizedId = eventId
      .toString()
      .replace(/^evt-/, '')
      .split('-')[0];
    return this.http.get(`${this.apiUrl}classroom/event/get-by-id/${normalizedId}`);
  }

  saveEventRemarks(eventId: string | number, Data: any) {
    console.log('Saving remarks for event ID:', eventId, 'with data:', Data);
    return this.http.post(`${this.apiUrl}classroom/schedule-day/${eventId}/remark`,Data );
  }

}
